import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route ,Redirect} from 'react-router-dom';
import Login from './views/Login';

import TnC from './views/Tnc';
import PrivacyPolicy from './views/PrivacyPolicy'
import DealerDispatch from './views/transaction/DealerDispatch';
import Layout from './template/Layout';
import ProductAuthentication from './views/ProductAuthentication';
import DiProduct from './views/DiProduct';
import GazetteNotification from './views/GazetteNotification';
import CarbN6G from './views/CarbN6G';
import HUMACID from './views/HUMACID';
import TAGLAMINA from './views/TAGLAMINA';
import TAGZYMEGR from './views/TAGZYMEGR';
import TROPICANA from './views/TROPICANA';
import BIONOL100 from './views/BIONOL100';
import SUPERPOWERG from './views/SUPERPOWERG';
import TAGBIO from './views/TAGBIO';
import TAGCALGR from './views/TAG-CAL-GR';
import TAGCAL from './views/TAG-CAL';
import { support } from 'jquery';
export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      login: false,
      authPage: 'other'
    }
  }
  
  componentDidMount() {
    debugger
    const urlParams = window.location.pathname;
    if (urlParams === '/privacy-policy') {
      this.setState({
        authPage: 'privacy-policy'
      })
    }
    else if (urlParams === '/di-details') {
      this.setState({
        authPage: 'di-details'
      })
    }
    else if (urlParams === '/gazette-notification') {
      this.setState({
        authPage: 'gazette-notification'
      })
    }

    else if (urlParams === '/carb-N6G') {
      this.setState({
        authPage: 'carb-N6G'
      })
    }
    else if (urlParams === '/humacid') {
      this.setState({
        authPage: 'humacid'
      })
    }
    else if (urlParams === '/taglamina') {
      this.setState({
        authPage: 'taglamina'
      })
    }
    else if (urlParams === '/tagzymegr') {
      this.setState({
        authPage: 'tagzymegr'
      })
    }
    else if (urlParams === '/tropicana') {
      this.setState({
        authPage: 'tropicana'
      })
    }

else if (urlParams === '/TAGBIO') {
      this.setState({
        authPage: 'TAGBIO'
      })
    }

    else if (urlParams === '/SUPERPOWERG') {
      this.setState({
        authPage: 'SUPERPOWERG'
      })
    }

    else if (urlParams === '/BIONOL100') {
      this.setState({
        authPage: 'BIONOL100'
      })
    }

    else if (urlParams === '/TAGCAL') {
      this.setState({
        authPage: 'TAG-CAL'
      })
    }

    else if (urlParams === '/TAGCALGR') {
      this.setState({
        authPage: 'TAG-CAL-GR'
      })
    }




    else if (urlParams === '/pa') {
      this.setState({
        authPage: 'pa'
      })
    }
    else {
      this.setState({
        authPage: 'other'
      })
    }
    if (this.state.authPage === 'other') {
      let storeCollector = JSON.parse(sessionStorage.getItem("LoggedInUser"));
      if (storeCollector && storeCollector.login) {
        this.setState({
          login: true
        })
      } else {
        this.setState({
          login: false
        })
      }
    }
  }

  render() {

    return (
      <>
        <Router>
          <Switch>
            {/* <Route path="/tnc" component={TnC} /> */}
            <Route path="/gazette-notification" Component={GazetteNotification} />
              <Route path="/carb-N6G" Component={CarbN6G} />
                <Route path="/humacid" Component={HUMACID} />
                  <Route path="/taglamina" Component={TAGLAMINA} />
                    <Route path="/tagzymegr" Component={TAGZYMEGR} />
                      <Route path="/tropicana" Component={TROPICANA} />
            <Route path="/privacy-policy" Component={PrivacyPolicy} />
            <Route path="/login" Component={Login} />
            <Route path="/dashboard" Component={Layout} />
            <Route path="/di-details" Component={DiProduct} />
            <Route path="/pa" Component={ProductAuthentication} />

            <Route path="/BIONOL100" Component={BIONOL100} />
            <Route path="/SUPERPOWERG" Component={SUPERPOWERG} />
            <Route path="/TAGBIO" Component={TAGBIO} />
            <Route path="/TAG-CAL-GR" Component={TAGCALGR} />
            {/* ✅ FIXED REDIRECT */}
    

    

            <Route path="/TAG-CAL" Component={TAGCAL} />
          </Switch>
        </Router>
       {/* <Route
       
      path="/transaction/dispatch"
      debugger
      render={(props) =>
        localStorage.getItem("usertype") === "7"
          ? <Redirect to="/transaction/dealer-dispatch" />
          : <Layout {...props} />
      }
    /> */}
        {this.state.authPage === 'di-details' ? <DiProduct /> :
          this.state.authPage === 'pa' ? <ProductAuthentication /> :
            this.state.authPage === 'privacy-policy' ? <PrivacyPolicy /> :
            this.state.authPage === 'gazette-notification' ? <GazetteNotification /> :
              this.state.authPage === 'carb-N6G' ? <CarbN6G /> :
                this.state.authPage === 'humacid' ? <HUMACID /> :
                  this.state.authPage === 'taglamina' ? <TAGLAMINA /> :
                    this.state.authPage === 'tagzymegr' ? <TAGZYMEGR /> :
                      this.state.authPage === 'tropicana' ? <TROPICANA /> :

                      this.state.authPage === 'BIONOL100' ? <BIONOL100 /> :
                      this.state.authPage === 'SUPERPOWERG' ? <SUPERPOWERG /> :
                      this.state.authPage === 'TAGBIO' ? <TAGBIO /> :
                      this.state.authPage === 'TAG-CAL-GR' ? <TAGCALGR /> :
                      this.state.authPage === 'TAG-CAL' ? <TAGCAL /> :
              this.state.login ? <Layout /> : <Login />
        }
        {/* {this.state.authPage === 'other' ?  (this.state.login ? <Layout /> : <Login />) : this.state.authPage === 'pa'? <ProductAuthentication /> : <TnC />} */}
      </>
    )
  }
}

